// react-slick injects some unwanted props into the arrow components, so we drop them to avoid
// a react warning. ref - https://github.com/akiran/react-slick/issues/623#issuecomment-629764816
export function DivWrapper({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  slideCount,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  currentSlide,
  ...props
}: React.ComponentProps<'div'> & {
  slideCount?: number
  currentSlide?: number
}) {
  return <div {...props} />
}
